import React, { Component } from 'react';

import Actions from './../flux/Actions';

import { __ } from "../Translator";
import { arrayChunk } from '../Helpers';

import ProductModel from '../components/ProductModel';
import Footer from "../components/Footer";
import Header from "../components/Header";
import StepIndicator from "../components/StepIndicator";
import LoadingSpinner from "../components/LoadingSpinner";
import AppActions from "../flux/AppActions";
import AppStore from "../flux/AppStore";

import './ModelSelection.css'
import CountryStore from '../flux/CountryStore';
import CountriesStore from '../flux/CountriesStore';
import shouldShowPrice from '../utils/shouldShowPrice';
import Store from '../flux/Store';

class ModelSelection extends Component {
  constructor(props) {
    super(props);
    this.initialCustomProduct = AppStore.getCustomProduct();
    if(this.initialCustomProduct !== null){

    }

    this.state = {
      country: CountriesStore.find(CountryStore.getState()),
      customProduct: AppStore.getCustomProduct(),
      products: props.products,
    };

    props.navigation.onBack(() => {
      props.navigation.navigate('productSelection');
    });

    this.onCustomProductInit = this.onCustomProductInit.bind(this);
  }

  componentDidMount() {
    AppStore.events.initCustomProduct.addListener(this.onCustomProductInit);

    // Probably no requests to the /product API has been made yet, let's do it
    // now (it happens when loading a custom product using its HASH and
    // navigating back
    if (this.state.products !== null && Object.keys(this.state.products).length === 0) {
      Actions.getProducts();
    }
  }

  componentWillUnmount() {
    AppStore.events.initCustomProduct.removeListener(this.onCustomProductInit);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      products: nextProps.products,
    });
  }

  onCustomProductInit() {
    this.setState({ customProduct: AppStore.getCustomProduct() });
  }

  onProductModelSelectClick(product) {
    if (this.state.customProduct && this.state.customProduct.product.code === product.code && this.state.customProduct.country_id === CountryStore.getState()) {
      this.props.navigation.navigate(product.perforable === null ? 'modelPerforate' : 'modelColor');
    } else {
      AppActions.initCustomProduct(product);
      Actions.getProduct(product.code);
      this.props.navigation.navigate(product.perforable === null? 'modelPerforate' : 'modelColor');
    }
  }

  intersectProductsWithOnlinePurchase(product){
    return (this.state.country.online_purchase === 1 && (product.custom_color === 0 || product.custom_fit === 1)) === false
  }

  render() {
    return (
      <div>
        <Header
          title={__('Configurator')}
          breadcrumb={['Homepage', 'Product']}
        />

        <Footer
          navigation={this.props.navigation}
          showNextButton={ !! this.state.products}
        />

        <StepIndicator currentScreen={this.props.navigation.currentScreen} />
        
        <div className="main">
          <div className="row">
            <div className="col-xs-8 col-xs-offset-2">

              <div className="main__hero">
                <h1 className="hero__title">{__('Pick your model')}</h1>
                <div className="hero__text">
                  <p>{__('These are the models available, choose the one you prefer.')}</p>
                </div>
              </div>

              <div className="modelSelection--shade" />

              <div className="modelSelection">
                <div className="modelContainer">
                  {(_products => {
                    if (Object.keys(_products).length === 0) {
                      return (
                        <LoadingSpinner isVisible={true} text={__('Loading products…')} />
                      );
                    }

                    const products = _products[AppStore.getProductCategory()].filter(product => this.intersectProductsWithOnlinePurchase(product));

                    if ( ! products) {
                      return (
                        <h4 className="text-center">{__('No products available.')}</h4>
                      );
                    }

                    const selectedProductCode = this.state.customProduct
                      ? this.state.customProduct.product.code
                      : null;

                    return (
                      arrayChunk(products, 3).map((row, index) => (
                        <div key={index} className="row">
                          {row.map(product => (
                            <div key={product.id} className="col-xs-4">
                              <ProductModel
                                product={product}
                                isSelected={product.code === selectedProductCode}
                                onSelectClick={product => this.onProductModelSelectClick(product)}
                              />
                            </div>
                          ))}
                        </div>
                      ))
                    );
                  })(this.state.products)}
                  <div className="clear" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ModelSelection;



// WEBPACK FOOTER //
// ./src/screens/ModelSelection.js